/**
 * Invisible input type data with magic number checks
 */
import { defineComponent, ref } from "vue";
import { MultipleMagicNumberChecks } from "../methods/multipleCheck";
export default defineComponent({
    props: {
        accept: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        multiple: Boolean,
    },
    emits: ["file-update"],
    setup(props, context) {
        /**
         * Invisible file inputs with magic number checks
         */
        const fileForm = ref(null);
        const uploadFileRef = ref(null);
        // input reset
        function reset() {
            if (!fileForm.value)
                return;
            fileForm.value.reset();
        }
        function parsedCallback(fileData) {
            // emit to go to the next step after files are checked
            context.emit("file-update", props.multiple ? fileData : fileData[0]);
        }
        const { filesCheck } = MultipleMagicNumberChecks(props.accept, parsedCallback, reset);
        function inputUpdate() {
            // check file mimetypes when files are selected
            filesCheck(uploadFileRef.value?.files || []);
        }
        return {
            fileForm,
            uploadFileRef,
            inputUpdate,
            reset,
        };
    },
});
